import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

export default function WhatsappTab() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  const setW = (patch) => setS((p) => ({ ...p, whatsapp: { ...p.whatsapp, ...patch } }));

  const save = async () => {
    try { await api.put("/admin/settings", { whatsapp: s.whatsapp }); toast.success("WhatsApp settings saved"); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!s) return <Loader2 className="animate-spin text-purple-400" />;
  const w = s.whatsapp;
  return (
    <div className="glass rounded-2xl p-5 space-y-4 max-w-xl">
      <p className="text-sm text-slate-400">On each booking, the café owner is notified via a pre-filled WhatsApp message opened automatically. No API keys required.</p>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={w.enabled} onChange={(e) => setW({ enabled: e.target.checked })} data-testid="toggle-whatsapp" /> WhatsApp Notifications Enabled</label>
      <div><label className="text-xs text-purple-400 font-mono">Owner WhatsApp Number (with country code, digits only)</label><Input value={w.number} onChange={(e) => setW({ number: e.target.value.replace(/[^0-9]/g, "") })} data-testid="whatsapp-number" placeholder="916003812416" className="mt-1 h-11 bg-purple-950/30 border-purple-500/30 font-mono" /></div>
      <div>
        <label className="text-xs text-purple-400 font-mono">Message Template</label>
        <textarea value={w.template} onChange={(e) => setW({ template: e.target.value })} rows={12} data-testid="whatsapp-template" className="mt-1 w-full rounded-xl bg-purple-950/30 border border-purple-500/30 p-3 text-sm font-mono" />
        <p className="text-xs text-slate-500 mt-1">Placeholders: {"{name} {phone} {date} {station} {setup} {start} {end} {duration} {amount} {payment} {booking_id}"}</p>
      </div>
      <Button onClick={save} data-testid="save-whatsapp" className="bg-emerald-600 hover:bg-emerald-500"><Save size={16} /> Save WhatsApp Settings</Button>
    </div>
  );
}
